import { Props as TooltipProps } from '../../../../../../../components/Tooltip';
import { OptionDetailsPopper, StyledRichTextView } from './styles';

export interface ChartTooltipProps extends DistributiveOmit<TooltipProps, 'ref' | 'title'> {
  title: string;
}

const ChartTooltip = ({ title, children, ...props }: ChartTooltipProps) => {
  return (
    <OptionDetailsPopper {...props} title={<StyledRichTextView richtext={title} />}>
      {children}
    </OptionDetailsPopper>
  );
};

export default ChartTooltip;
